import { render, staticRenderFns } from "./PanelFrame.vue?vue&type=template&id=0334e44a&scoped=true&lang=pug&"
import script from "./PanelFrame.vue?vue&type=script&lang=ts&"
export * from "./PanelFrame.vue?vue&type=script&lang=ts&"
import style0 from "./PanelFrame.vue?vue&type=style&index=0&id=0334e44a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334e44a",
  null
  
)

export default component.exports